export const NewOrderImpressionsMode = {
  CR: "CR",
  Impressions: "Impressions",
} as const;

export type TNewOrderImpressionsMode =
  (typeof NewOrderImpressionsMode)[keyof typeof NewOrderImpressionsMode];
